"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Do not edit this file, it is automatically generated by @paprika/build-translations
var locales = {
    "fr": {
        "translation": {
            "global_navigation": {
                "navigation_items": {
                    "logo": "Retour vers la Barre de lancement",
                    "app_switcher": "Basculer d'une appli à l'autre",
                    "announcer": "Annonces",
                    "helper": "Aide et Assistance",
                    "user": "Connecté(e) : {{username}}",
                    "user_with_customer": "{{username}} {{customerName}}",
                    "sign_in": "Connexion"
                },
                "apps": {
                    "academy": "Académie",
                    "community": "Communauté",
                    "projects": "Projets",
                    "results": "Résultats",
                    "storyboards": "Storyboards",
                    "mission_control": "Suivi des contrôles",
                    "risks": "Stratégie",
                    "reports": "Rapports",
                    "launchpad": "Barre de lancement",
                    "robots": "Robots",
                    "frameworks": "Cadres",
                    "compliance_maps": "Cartes de conformité",
                    "assurance_plans": "Plans d'assurance",
                    "project_scheduler": "Planificateur",
                    "issue_tracker": "Outil de suivi des problèmes",
                    "task_tracker": "Outil de suivi des tâches",
                    "project_timesheets": "Relevés des temps",
                    "dashboard": "Tableau de bord pour {{module}}",
                    "master_library": "Bibliothèque de base"
                },
                "app_sections": {
                    "setup": "Configuration",
                    "workspace": "Environnement de travail",
                    "automation": "Automatisation"
                },
                "user": {
                    "my_profile": "Mon profil",
                    "log_out": "Déconnexion"
                },
                "helper": {
                    "help_docs": "Documentation d'aide",
                    "support": "Assistance"
                },
                "skip_button": "Passer au contenu principal",
                "logo": "logo",
                "other": "Autres",
                "section": "section"
            }
        }
    }
};
exports.default = locales;
//# sourceMappingURL=fr.js.map